<template>
    <div>
    </div>
    </template>
<script>
import axios from '../../../plugins/axios'
import Swal from 'sweetalert2'
const ls = require('local-storage')
export default {
  data: () => ({
    configuracoes: ls.get('configuracoesReport'),
    historico_relatorio: '',
    componente1: [],
    componente2: [],
    componente3: [],
    componente4: [],
    historicoNotas: [],
    empresa: {
      decreto: 'Decreto nº 207/11 de 2 de Agosto de 2011',
      distrito: 'Distrito Urbano 11 de Novembro',
      nif: '5417113387',
      provincia: 'Luanda',
      municipio: 'Cazenga',
      dataemissao: '27/08/1999',
      pais: 'Angola',
      email: 'colegioilhadaverdade2021@gmail.com',
      telefone1: '(+22) 923716242',
      telefone2: '222788370'
    },
    estudante_dados: [],
    relatorio: ls.get('relatorio-estudante'),
    html: ``,
    titulo: ''
  }),
  computed: {
  },
  watch: {
  },
  created  () {
    this.estudante_dados = this.$store.state.listEstudantfromPauta // this.$store.state.objAluno
    this.carregarRelatorio()
  },
  methods: {

    async carregarRelatorio () {
      try {
        this.historico_relatorio = await axios
          .get('/obterRelatorio/' + this.relatorio.id)
          .then(res => res.data)
        this.titulo = 'A Ficha de Dados Biográfico Académico'
        this.carregarNota()
      } catch (error) {
        this.sair()
        Swal.fire({
          icon: 'error',
          title: '',
          text: 'Ocorreu um erro ao carregar o relatório'
        })
      }
    },
    async carregarNota () {
      try {
        let finalista = this.estudante_dados[0]
        let notas = await axios
          .post('/obter-historicoNotas', finalista)
          .then(res => res.data)
        this.carregarNotasFichadadosBiografico(notas)
      } catch (error) {

      }
    },
    async carregarNotasFichadadosBiografico (notas) {
      try {
        /** ---------------------------------Filtrar inscrições na turma em relação a classe */
        // @ts-ignore
        let inscricao1 = this.estudante_dados.filter(e => e.idAno_Academico === 1)

        // @ts-ignore
        let inscricao2 = this.estudante_dados.filter(e => e.idAno_Academico === 2)

        // @ts-ignore
        let inscricao3 = this.estudante_dados.filter(e => e.idAno_Academico === 3)

        // @ts-ignore
        let inscricao4 = this.estudante_dados.filter(e => e.idAno_Academico === 4)
        let foto = (ls.get('urlReport') + 'readphoto/' + this.estudante_dados[0].foto)

        /** ---------------------------------Substituir o primeiro cabeçalho  */
        // @ts-ignore
        let documento = this.historico_relatorio[0].documento
        // @ts-ignore
        documento = documento.replace(/{{curso}}/g, this.estudante_dados[0].curso.toUpperCase())
        documento = documento.replace(/{{logotipoInstituicao}}/g, ls.get('logotipo'))
        documento = documento.replace(/{{fotoestudante}}/g, foto)
        documento = documento.replace(/{{instituicao}}/g, ls.get('instituicaodescricao').toUpperCase())
        // @ts-ignore
        documento = documento.replace(/{{nomeAluno}}/g, this.estudante_dados[0].nome.toUpperCase())
        // @ts-ignore
        documento = documento.replace(/{{nomedopai}}/g, this.estudante_dados[0].nomedopai)
        // @ts-ignore
        documento = documento.replace(/{{nomedamae}}/g, this.estudante_dados[0].nomedamae)

        // @ts-ignore
        documento = documento.replace(/{{municipio}}/g, this.estudante_dados[0].municipio)
        // @ts-ignore
        documento = documento.replace(/{{provincia}}/g, this.estudante_dados[0].provincia)

        const datadenascimento = (this.estudante_dados[0].datanascimento)
        const datadeemissao = (this.estudante_dados[0].dataemissaobi)
        documento = documento.replace(/{{datanascimento}}/g, (datadenascimento.length ? datadenascimento : ''))
        documento = documento.replace(/{{dataemissaobi}}/g, (datadeemissao.length ? datadeemissao : ''))
        // @ts-ignore
        documento = documento.replace(/{{bi}}/g, this.estudante_dados[0].bi)
        // @ts-ignore
        documento = documento.replace(/{{matricula}}/g, this.estudante_dados[0].idMatricula)
        documento = documento.replace(/{{directorIMS}}/g, ls.get('directora_ims'))
        documento = documento.replace(/{{profissaoDirectorIMS}}/g, '*' + ls.get('directora_ims_profissao') + '*')
        documento = documento.replace(/{{subdirector}}/g, ls.get('subdirector'))

        /** **** -------------------------------------Definir cabeçalho da tabela disciplina e notas -------------------------------- */
        let contadorInscricoesFeitas = (inscricao4.length ? 4 : inscricao3.length ? 3 : inscricao2.length ? 2 : 1)
        // @ts-ignore
        this.historico_relatorio[0].documentoiteracao1 = this.historico_relatorio[0].documentoiteracao1.replace(/{{matricula}}/g, this.estudante_dados[0].idMatricula)
        // @ts-ignore
        this.historico_relatorio[0].documentoiteracao1 = this.historico_relatorio[0].documentoiteracao1.replace(/{{instituicao}}/g, ls.get('nomeInstituicao').toUpperCase())
        let inscricaonaturmaHtml = this.comporCabecalhoInscricoes(inscricao1, inscricao2, inscricao3, inscricao4)
        // @ts-ignore
        let cabecalhodisciplina = this.comporCabecalhoAvaliacao(contadorInscricoesFeitas, this.historico_relatorio[0].documentoiteracao2, this.historico_relatorio[0].documentoiteracao3)
        documento = documento.replace(/{{inscricaonaturma}}/g, inscricaonaturmaHtml)
        // @ts-ignore
        documento = documento.replace(/{{avaliacoes1}}/g, cabecalhodisciplina[0])
        // @ts-ignore
        documento = documento.replace(/{{avaliacoes2}}/g, cabecalhodisciplina[1])
        /** **** --------------------------------------------------------------------- */

        this.historicoNotas = await axios
          .post('/obter-disciplinas-pauta-modelo', this.estudante_dados[0])
          .then(res => res.data)
        /** *--------------------------------------Filtrar notas em relação aos componentes das disciplinas */
        // @ts-ignore
        this.componente1 = this.historicoNotas.filter(p => p.componente === 1)

        // @ts-ignore
        this.componente2 = this.historicoNotas.filter(p => p.componente === 2)

        // @ts-ignore
        this.componente3 = this.historicoNotas.filter(p => p.componente === 3)

        this.html = documento // Setar os cabeçalhos do documento
        /** ---------------------------------------------- Compor dados das disciplinas e notas pertencentes a componente 1 */
        this.iterarComponente1_fichaDadosBiografico(notas, contadorInscricoesFeitas)
      } catch (error) {
        console.log(error)
        this.sair()
        Swal.fire({
          icon: 'error',
          title: '',
          text: 'Ocorreu um erro ao carregar as notas'
        })
      }
    },
    comporCabecalhoAvaliacao (quantClasse, av1, av2) {
      try {
        switch (quantClasse) {
          case 1:
            return [av1, av2]
          case 2:
            return [(av1 + av1), (av2 + av2)]
          case 3:
            return [(av1 + av1 + av1), (av2 + av2 + av2)]
          case 4:
            return [(av1 + av1 + av1 + av1), (av2 + av2 + av2 + av2)]

          default:
            return ['', '']
        }
      } catch (error) {
        this.sair()
        Swal.fire({
          icon: 'error',
          title: '',
          text: 'Ocorreu um erro ao carregar as notas'
        })
      }
    },
    // @ts-ignore
    comporCabecalhoInscricoes (inscricao1, inscricao2, inscricao3, inscricao4) {
      try {
        // @ts-ignore
        let documento1 = this.historico_relatorio[0].documentoiteracao1
        documento1 = documento1.replace(/{{turma}}/g, (inscricao1.length ? inscricao1[0].descricao_turma : ''))
        documento1 = documento1.replace(/{{anolectivo}}/g, (inscricao1.length ? inscricao1[0].anoLectivo : ''))
        documento1 = documento1.replace(/{{classe}}/g, (inscricao1.length ? inscricao1[0].classe : ''))

        // @ts-ignore
        let documento2 = ((inscricao2.length || inscricao3.length || inscricao4.length) ? this.historico_relatorio[0].documentoiteracao1 : '')
        documento2 = documento2.replace(/{{turma}}/g, (inscricao2.length ? inscricao2[0].descricao_turma : ''))
        documento2 = documento2.replace(/{{anolectivo}}/g, (inscricao2.length ? inscricao2[0].anoLectivo : ''))
        documento2 = documento2.replace(/{{classe}}/g, (inscricao2.length ? inscricao2[0].classe : ''))

        // @ts-ignore
        let documento3 = ((inscricao3.length || inscricao4.length) ? this.historico_relatorio[0].documentoiteracao1 : '')
        documento3 = documento3.replace(/{{turma}}/g, (inscricao3.length ? inscricao3[0].descricao_turma : ''))
        documento3 = documento3.replace(/{{anolectivo}}/g, (inscricao3.length ? inscricao3[0].anoLectivo : ''))
        documento3 = documento3.replace(/{{classe}}/g, (inscricao3.length ? inscricao3[0].classe : ''))

        // @ts-ignore
        let documento4 = ((inscricao4.length) ? this.historico_relatorio[0].documentoiteracao1 : '')
        documento4 = documento4.replace(/{{turma}}/g, (inscricao4.length ? inscricao4[0].descricao_turma : ''))
        documento4 = documento4.replace(/{{anolectivo}}/g, (inscricao4.length ? inscricao4[0].anoLectivo : ''))
        documento4 = documento4.replace(/{{classe}}/g, (inscricao4.length ? inscricao4[0].classe : ''))

        return documento1 + documento2 + documento3 + documento4
      } catch (error) {
        this.sair()
        Swal.fire({
          icon: 'error',
          title: '',
          text: 'Ocorreu um erro'
        })
      }
    },
    /** Componente 1 */
    iterarComponente1_fichaDadosBiografico (notas, contadorInscricoesFeitas) {
      try {
        let componenteHtml = ``
        for (let index = 0; index < this.componente1.length; index++) {
          const element = this.componente1[index]
          const linha = notas.filter(n => n.disciplina === element.descricao)
          if (index === 0) {
            // @ts-ignore
            this.html = this.html.replace(/{{totaldisciplinas1}}/g, this.componente1.length)
            // @ts-ignore
            let documentoIteracao1 = (contadorInscricoesFeitas >= 1 ? this.historico_relatorio[0].documentoiteracao4 : '')
            // @ts-ignore
            let documentoIteracao2 = (contadorInscricoesFeitas >= 2 ? this.historico_relatorio[0].documentoiteracao4 : '')
            // @ts-ignore
            let documentoIteracao3 = (contadorInscricoesFeitas >= 3 ? this.historico_relatorio[0].documentoiteracao4 : '')
            // @ts-ignore
            let documentoIteracao4 = (contadorInscricoesFeitas === 4 ? this.historico_relatorio[0].documentoiteracao4 : '')

            documentoIteracao1 = documentoIteracao1.replace(/{{media}}/g, (linha.length ? (linha[0].classe1) : ''))

            documentoIteracao2 = documentoIteracao2.replace(/{{media}}/g, (linha.length ? (linha[0].classe2) : ''))

            documentoIteracao3 = documentoIteracao3.replace(/{{media}}/g, (linha.length ? (linha[0].classe3) : ''))

            documentoIteracao4 = documentoIteracao4.replace(/{{media}}/g, (linha.length ? (linha[0].classe4) : ''))

            componenteHtml = `<td style="text-align:justify;" width="40%">` + element.descricao + `</td>` + documentoIteracao1 + documentoIteracao2 + documentoIteracao3 + documentoIteracao4 + '</tr>'
          } else {
            // @ts-ignore
            let documentoIteracao1 = (contadorInscricoesFeitas >= 1 ? this.historico_relatorio[0].documentoiteracao4 : '')
            // @ts-ignore
            let documentoIteracao2 = (contadorInscricoesFeitas >= 2 ? this.historico_relatorio[0].documentoiteracao4 : '')
            // @ts-ignore
            let documentoIteracao3 = (contadorInscricoesFeitas >= 3 ? this.historico_relatorio[0].documentoiteracao4 : '')
            // @ts-ignore
            let documentoIteracao4 = (contadorInscricoesFeitas === 4 ? this.historico_relatorio[0].documentoiteracao4 : '')

            documentoIteracao1 = documentoIteracao1.replace(/{{media}}/g, (linha.length ? (linha[0].classe1) : ''))

            documentoIteracao2 = documentoIteracao2.replace(/{{media}}/g, (linha.length ? (linha[0].classe2) : ''))

            documentoIteracao3 = documentoIteracao3.replace(/{{media}}/g, (linha.length ? (linha[0].classe3) : ''))

            documentoIteracao4 = documentoIteracao4.replace(/{{media}}/g, (linha.length ? (linha[0].classe4) : ''))

            componenteHtml += '<tr><td style="text-align:justify;" width="40%">' + element.descricao + '</td>' + documentoIteracao1 + documentoIteracao2 + documentoIteracao3 + documentoIteracao4 + '</tr>'
          }
        }
        /** ---------------------------------------------- Compor dados das disciplinas e notas pertencentes a componente 2 */
        this.iterarComponente2_fichaDadosBiografico(componenteHtml, notas, contadorInscricoesFeitas)
      } catch (error) {
        this.sair()
        Swal.fire({
          icon: 'error',
          title: '',
          text: 'Ocorreu um erro'
        })
      }
    },
    /** Componente 2 */
    iterarComponente2_fichaDadosBiografico (c1, notas, contadorInscricoesFeitas) {
      try {
        let componenteHtml = ``
        for (let index = 0; index < this.componente2.length; index++) {
          const element = this.componente2[index]
          const linha = notas.filter(n => n.disciplina === element.descricao)
          if (index === 0) {
            // @ts-ignore
            this.html = this.html.replace(/{{totaldisciplinas2}}/g, this.componente2.length)
            // @ts-ignore
            let documentoIteracao1 = (contadorInscricoesFeitas >= 1 ? this.historico_relatorio[0].documentoiteracao4 : '')
            // @ts-ignore
            let documentoIteracao2 = (contadorInscricoesFeitas >= 2 ? this.historico_relatorio[0].documentoiteracao4 : '')
            // @ts-ignore
            let documentoIteracao3 = (contadorInscricoesFeitas >= 3 ? this.historico_relatorio[0].documentoiteracao4 : '')
            // @ts-ignore
            let documentoIteracao4 = (contadorInscricoesFeitas === 4 ? this.historico_relatorio[0].documentoiteracao4 : '')

            documentoIteracao1 = documentoIteracao1.replace(/{{disciplina}}/g, element.descricao)
            documentoIteracao1 = documentoIteracao1.replace(/{{media}}/g, (linha.length ? (linha[0].classe1) : ''))

            documentoIteracao2 = documentoIteracao2.replace(/{{disciplina}}/g, element.descricao)
            documentoIteracao2 = documentoIteracao2.replace(/{{media}}/g, (linha.length ? (linha[0].classe2) : ''))

            documentoIteracao3 = documentoIteracao3.replace(/{{disciplina}}/g, element.descricao)
            documentoIteracao3 = documentoIteracao3.replace(/{{media}}/g, (linha.length ? (linha[0].classe3) : ''))

            documentoIteracao4 = documentoIteracao4.replace(/{{disciplina}}/g, element.descricao)
            documentoIteracao4 = documentoIteracao4.replace(/{{media}}/g, (linha.length ? (linha[0].classe4) : ''))

            componenteHtml = `<td style="text-align:justify;" width="40%">` + element.descricao + `</td>` + documentoIteracao1 + documentoIteracao2 + documentoIteracao3 + documentoIteracao4 + '</tr>'
          } else {
            // @ts-ignore
            let documentoIteracao1 = (contadorInscricoesFeitas >= 1 ? this.historico_relatorio[0].documentoiteracao4 : '')
            // @ts-ignore
            let documentoIteracao2 = (contadorInscricoesFeitas >= 2 ? this.historico_relatorio[0].documentoiteracao4 : '')
            // @ts-ignore
            let documentoIteracao3 = (contadorInscricoesFeitas >= 3 ? this.historico_relatorio[0].documentoiteracao4 : '')
            // @ts-ignore
            let documentoIteracao4 = (contadorInscricoesFeitas === 4 ? this.historico_relatorio[0].documentoiteracao4 : '')

            documentoIteracao1 = documentoIteracao1.replace(/{{disciplina}}/g, element.descricao)
            documentoIteracao1 = documentoIteracao1.replace(/{{media}}/g, (linha.length ? (linha[0].classe1) : ''))

            documentoIteracao2 = documentoIteracao2.replace(/{{disciplina}}/g, element.descricao)
            documentoIteracao2 = documentoIteracao2.replace(/{{media}}/g, (linha.length ? (linha[0].classe2) : ''))

            documentoIteracao3 = documentoIteracao3.replace(/{{disciplina}}/g, element.descricao)
            documentoIteracao3 = documentoIteracao3.replace(/{{media}}/g, (linha.length ? (linha[0].classe3) : ''))

            documentoIteracao4 = documentoIteracao4.replace(/{{disciplina}}/g, element.descricao)
            documentoIteracao4 = documentoIteracao4.replace(/{{media}}/g, (linha.length ? (linha[0].classe4) : ''))

            componenteHtml += '<tr><td style="text-align:justify;" width="40%">' + element.descricao + '</td>' + documentoIteracao1 + documentoIteracao2 + documentoIteracao3 + documentoIteracao4 + '</tr>'
          }
        }
        /** ---------------------------------------------- Compor dados das disciplinas e notas pertencentes a componente 1 */
        this.iterarComponente3_fichaDadosBiografico(c1, componenteHtml, notas, contadorInscricoesFeitas)
      } catch (error) {
        this.sair()
        Swal.fire({
          icon: 'error',
          title: '',
          text: 'Ocorreu um erro'
        })
      }
    },
    /** Componente 2 */
    iterarComponente3_fichaDadosBiografico (c1, c2, notas, contadorInscricoesFeitas) {
      try {
        let componenteHtml = ``
        for (let index = 0; index < this.componente3.length; index++) {
          const element = this.componente3[index]
          const linha = notas.filter(n => n.disciplina === element.descricao)

          if (index === 0) {
            // @ts-ignore
            this.html = this.html.replace(/{{totaldisciplinas3}}/g, this.componente3.length)
            // @ts-ignore
            let documentoIteracao1 = (contadorInscricoesFeitas >= 1 ? this.historico_relatorio[0].documentoiteracao4 : '')
            // @ts-ignore
            let documentoIteracao2 = (contadorInscricoesFeitas >= 2 ? this.historico_relatorio[0].documentoiteracao4 : '')
            // @ts-ignore
            let documentoIteracao3 = (contadorInscricoesFeitas >= 3 ? this.historico_relatorio[0].documentoiteracao4 : '')
            // @ts-ignore
            let documentoIteracao4 = (contadorInscricoesFeitas === 4 ? this.historico_relatorio[0].documentoiteracao4 : '')

            documentoIteracao1 = documentoIteracao1.replace(/{{disciplina}}/g, element.descricao)
            documentoIteracao1 = documentoIteracao1.replace(/{{media}}/g, (linha.length ? (linha[0].classe1) : ''))

            documentoIteracao2 = documentoIteracao2.replace(/{{disciplina}}/g, element.descricao)
            documentoIteracao2 = documentoIteracao2.replace(/{{media}}/g, (linha.length ? (linha[0].classe2) : ''))

            documentoIteracao3 = documentoIteracao3.replace(/{{disciplina}}/g, element.descricao)
            documentoIteracao3 = documentoIteracao3.replace(/{{media}}/g, (linha.length ? (linha[0].classe3) : ''))

            documentoIteracao4 = documentoIteracao4.replace(/{{disciplina}}/g, element.descricao)
            documentoIteracao4 = documentoIteracao4.replace(/{{media}}/g, (linha.length ? (linha[0].classe4) : ''))

            componenteHtml = `<td style="text-align:justify;" width="40%">` + element.descricao + `</td>` + documentoIteracao1 + documentoIteracao2 + documentoIteracao3 + documentoIteracao4 + '</tr>'
          } else {
            // @ts-ignore
            let documentoIteracao1 = (contadorInscricoesFeitas >= 1 ? this.historico_relatorio[0].documentoiteracao4 : '')
            // @ts-ignore
            let documentoIteracao2 = (contadorInscricoesFeitas >= 2 ? this.historico_relatorio[0].documentoiteracao4 : '')
            // @ts-ignore
            let documentoIteracao3 = (contadorInscricoesFeitas >= 3 ? this.historico_relatorio[0].documentoiteracao4 : '')
            // @ts-ignore
            let documentoIteracao4 = (contadorInscricoesFeitas === 4 ? this.historico_relatorio[0].documentoiteracao4 : '')

            documentoIteracao1 = documentoIteracao1.replace(/{{disciplina}}/g, element.descricao)
            documentoIteracao1 = documentoIteracao1.replace(/{{media}}/g, (linha.length ? (linha[0].classe1) : ''))

            documentoIteracao2 = documentoIteracao2.replace(/{{disciplina}}/g, element.descricao)
            documentoIteracao2 = documentoIteracao2.replace(/{{media}}/g, (linha.length ? (linha[0].classe2) : ''))

            documentoIteracao3 = documentoIteracao3.replace(/{{disciplina}}/g, element.descricao)
            documentoIteracao3 = documentoIteracao3.replace(/{{media}}/g, (linha.length ? (linha[0].classe3) : ''))

            documentoIteracao4 = documentoIteracao4.replace(/{{disciplina}}/g, element.descricao)
            documentoIteracao4 = documentoIteracao4.replace(/{{media}}/g, (linha.length ? (linha[0].classe4) : ''))

            componenteHtml += '<tr><td style="text-align:justify;" width="40%">' + element.descricao + '</td>' + documentoIteracao1 + documentoIteracao2 + documentoIteracao3 + documentoIteracao4 + '</tr>'
          }
        }
        this.comporFichaDadosBiografico(c1, c2, componenteHtml)
      } catch (error) {
        this.sair()
        Swal.fire({
          icon: 'error',
          title: '',
          text: 'Ocorreu um erro'
        })
      }
    },
    async comporFichaDadosBiografico (itercomponente1, itercomponente2, itercomponente3) {
      try {
        /** Componente 1 */
        this.html = this.html.replace(/{{componente1}}/g, itercomponente1)
        /** Componente 2 */
        this.html = this.html.replace(/{{componente2}}/g, itercomponente2)
        /** Componente 3 */
        this.html = this.html.replace(/{{componente3}}/g, itercomponente3)
        let option = { 'format': 'A4',
          'orientation': 'landscape',
          'border': {
            'right': '5mm',
            'left': '5mm'
          },
          'header': {
            'height': '4mm' },
          'footer': {
            'height': '2mm'
          } }
        this.gerarPdf(option)
      } catch (error) {
        this.sair()
        Swal.fire({
          icon: 'error',
          title: '',
          text: 'Ocorreu um erro'
        })
      }
    },
    async gerarPdf (option) {
      try {
        await axios({
          method: 'post',
          url: ls.get('urlReport') + 'writefile',
          data: {
            html: this.html,
            file_name: ls.get('idPessoa'),
            option: option
          }
        }).then((res) => res.data)
        this.frame()
      } catch (error) {
        this.sair()
        Swal.fire({
          icon: 'error',
          title: '',
          text: 'Ocorreu um erro'
        })
      }
    },
    frame () {
      this.sair()
      let readfile = ls.get('urlReport') + 'readfile/' + ls.get('idPessoa') + '.pdf'
      let frame = `<html> +
          <style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style> 
          <body>
          <iframe target="_blank" type="application/pdf" src="` + readfile + `"></iframe> 
          </body></html>`
      let a = window.open('about:blank', '_blank', '', true)
      a.document.write(frame)
      a.document.close()
    },
    sair () {
      this.$store.state.isloading = false
      this.$store.state.showDialogGuia.ficha = false
    },
    dataActual () {
      let data = new Date()
      var month = []
      month[0] = 'Janeiro'
      month[1] = 'Fevereiro'
      month[2] = 'Março'
      month[3] = 'Abril'
      month[4] = 'Maio'
      month[5] = 'Junho'
      month[6] = 'Julho'
      month[7] = 'Agosto'
      month[8] = 'Setembro'
      month[9] = 'Outubro'
      month[10] = 'Novembro'
      month[11] = 'Dezembro'
      return data.getDate().toString() + ' de ' + month[(data.getMonth())] + ' de ' + data.getFullYear().toString()
    },
    dataExtensao (dateString) {
      // dateString = dateString.split('/')
      dateString = dateString.split('-')
      var month = []
      month[0] = 'Janeiro'
      month[1] = 'Fevereiro'
      month[2] = 'Março'
      month[3] = 'Abril'
      month[4] = 'Maio'
      month[5] = 'Junho'
      month[6] = 'Julho'
      month[7] = 'Agosto'
      month[8] = 'Setembro'
      month[9] = 'Outubro'
      month[10] = 'Novembro'
      month[11] = 'Dezembro'
      return dateString[0] + ' de ' + month[parseInt(dateString[1]) - 1] + ' de ' + dateString[2]
    },
    dataExtensaobi (dateString) {
      // dateString = dateString.split('/')
      dateString = dateString.split('-')
      var month = []
      month[0] = 'Janeiro'
      month[1] = 'Fevereiro'
      month[2] = 'Março'
      month[3] = 'Abril'
      month[4] = 'Maio'
      month[5] = 'Junho'
      month[6] = 'Julho'
      month[7] = 'Agosto'
      month[8] = 'Setembro'
      month[9] = 'Outubro'
      month[10] = 'Novembro'
      month[11] = 'Dezembro'
      return dateString[0] + ' de ' + month[parseInt(dateString[1]) - 1] + ' de ' + dateString[2]
    }
  }
}

</script>
